import { Link } from 'react-router-dom';
import { ArrowRight, Home, Search } from 'lucide-react';
import './NotFound.css';

const links = [
  { label: 'Services', path: '/services' },
  { label: 'Products', path: '/products' },
  { label: 'Blog', path: '/blog' },
  { label: 'ERP software', path: '/erp-software' },
  { label: 'Pricing', path: '/pricing' },
  { label: 'Contact', path: '/contact' },
];

const NotFound = () => (
  <>
    <title>Page Not Found | Pidesk</title>
    <meta name="description" content="The page you are looking for does not exist or may have moved." />
    <meta name="robots" content="noindex, follow" />

    <div className="nf-page">
      <div className="container nf-hero">
        <span className="nf-code">404</span>
        <h1 className="nf-title">We couldn't find that page</h1>
        <p className="nf-subtitle">
          The page you are looking for does not exist, may have moved, or the link might have a typo.
        </p>
        <div className="nf-actions">
          <Link to="/" className="btn btn-primary btn-lg">
            <Home size={18} style={{ marginRight: 8 }} /> Back to home
          </Link>
          <Link to="/contact" className="btn btn-secondary btn-lg">
            Talk to us <ArrowRight size={18} style={{ marginLeft: 8 }} />
          </Link>
        </div>

        <div className="nf-links">
          <span className="nf-links-label"><Search size={14} /> Or try one of these</span>
          <div className="nf-links-grid">
            {links.map((l) => (
              <Link key={l.path} to={l.path} className="nf-link">
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  </>
);

export default NotFound;
